export default __webpack_public_path__ + "static/media/archived_pid.4204a380.png";